import axios from "axios";
import Vue from "vue";
import { EventBus } from '@/common/utils/event-bus'

const ajax = axios.create({
  withCredentials: true,
  baseURL: "",
  timeout: 30000
});

/* eslint-disable */

 ajax.interceptors.request.use(function (config) {
        if (!!window.abp.auth.getToken()) {
             config.headers.common["Authorization"] = "Bearer " + window.abp.auth.getToken();
         }
         config.headers.common[".AspNetCore.Culture"] = window.abp.utils.getCookieValue("Abp.Localization.CultureName");
         config.headers.common["Abp.TenantId"] = window.abp.multiTenancy.getTenantIdCookie();

         config.headers.common["Cache-control"] = "no-cache";
         config.headers.common["Cache-control"] = "no-store";
         config.headers.common["Pragma"] = "no-cache";
         config.headers.common["Expires"] = 0;

         return config;
     }, function (error) {

         return Promise.reject(error);
});


let vm = new Vue({});


ajax.interceptors.response.use((respon) => {
        return respon
    }, (error) => {
        if (!!error.response && !!error.response.data.error && !!error.response.data.error.message && error.response.data.error.details) {

            vm.$swal({
                title: error.response.data.error.message,
                text: error.response.data.error.details,
                type: 'error',
                confirmButtonText: 'Zavřít',
            });

        } else if (!!error.response && !!error.response.data.error && !!error.response.data.error.message) {

            vm.$swal({
                title: window.abp.localization.localize("base_result_Error", "MyeID"),
                text: error.response.data.error.message,
                type: 'error',
                confirmButtonText: 'Zavřít',
            });

        } else if (!error.response && error.code !== "ECONNABORTED") {

            vm.$swal({
                title: window.abp.localization.localize('Chyba'),
                text: "Došlo k neočekáváné chybě",
                type: 'error',
                confirmButtonText: 'Zavřít',
            });

        } else if (error.code === "ECONNABORTED") {
            console.warn("Request timeout.");
        }

        EventBus.$emit("page-loading-off");

        return Promise.reject(error.response);
})

export default ajax;
